import { getDocumentChartTheme, toHex6 } from '@/components/charts/theme';

/**
 * The opaque fill behind every image export: the card surface of the theme on screen, so an
 * export looks like the page it came from and never has a transparent background. PDFs are the
 * exception: they are always light (usePDFExport, DownloadPDF).
 *
 * Read when the export runs, not when a component rendered, so an export started right after
 * a theme switch still matches the page. The value comes through the chart theme bridge, which
 * already resolves the surface token to a 6-digit hex that html-to-image and jsPDF both accept,
 * and falls back to the light value where no stylesheet is loaded.
 */
export function getExportBackground(): string {
    return getDocumentChartTheme().surface;
}

export type RgbTuple = readonly [r: number, g: number, b: number];

/** A hex colour as 0-255 channels, or null when it is not `#rgb` or `#rrggbb`. */
export function hexToRgbTuple(color: string): RgbTuple | null {
    const hex = toHex6(color);
    if (!hex) return null;
    const channel = (start: number): number => Number.parseInt(hex.slice(start, start + 2), 16);
    return [channel(1), channel(3), channel(5)];
}
